import React, { useState, useEffect } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import godaddyImage from './../assets/images/globle.png';
import logoImage from './../assets/images/logo.png';
import directDebit from './../assets/images/direct-1.png';
import { useFormik } from 'formik';
import * as yup from 'yup';
import PriceSummery from '../component/PriceSummery';
import {
    Link,
    useNavigate
} from 'react-router-dom';
import MonekPaymentForm from '../component/MonekPaymentForm';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';
import Footer from '../component/Footer';
import Header from '../component/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './payment.css';









const schema = yup.object().shape({
    accountNumber: yup
        .string()
        .transform(value => value?.padStart(8, '0')) // Pad to 8 digits
        .matches(/^\d{8}$/, 'Account number must be 8 digits')
        .required('Account number is required'),

    shortcode: yup
        .string()
        .transform(value => value?.replace(/-/g, '').padStart(6, '0')) // Remove dashes, pad to 6 digits
        .matches(/^(\d{6})$/, 'Sort code must be 6 digits')
        .required('Sort code is required'),

    address1: yup.string().required('Address Line 1 is required'),
    address2: yup.string(),
    address3: yup.string(),
    postcode: yup.string().required('Postcode is required'),
    country: yup.string(),
    phoneNumber: yup.string(),
    email: yup.string().email('Invalid email address').required('Email is required'),
});






function BankDetails() {
    const navigate = useNavigate();
    const userData = useSelector((state) => state.user.user);
    const fullPrice = useSelector((state) => state.paymentSummery.fullPrice);
    const depositPrice = useSelector((state) => state.paymentSummery.depositPrice);
    const plan = useSelector((state) => state.paymentSummery.plan);
    const selectInsurerType = useSelector((state) => state.paymentSummery.selectInsurerType);
    const aiDepositPrice = useSelector((state) => state.paymentSummery.aiDepositPrice);
    const aitotalPrice = useSelector((state) => state.paymentSummery.aitotalPrice);
    const selectedAddons = useSelector((state) => state.paymentSummery.selectedAddons);
    const userEmail = useSelector((state) => state.paymentSummery.userEmail);
    const brokerFee = useSelector((state) => state.paymentSummery.brokerFee);
    const userLoginType = useSelector((state) => state.user.loginType);
    const [summaryData, setSummaryData] = useState({});
    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);
    const [showPaymentForm, setShowPaymentForm] = useState(false);

    const [cardInfoCorrect, setCardInfoCorrect] = useState('yes');
    const [showComplianceInfo, setShowComplianceInfo] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (userData?.PaymentDetails) {
            const currentPremium = userLoginType === "Lapse" ? parseFloat(userData.PaymentDetails.Premium || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerPremium || "0");
            const alternativePremium = parseFloat(userData.PaymentDetails.AlternativeInsurerPremium || "0");
            const premiumFailed = parseFloat(userData.PaymentDetails.Premium || "0");

            let displayData = {};

            if (!currentPremium) {
                displayData = {
                    showAlternative: true,
                    alternativePremium,
                };
            } else if (!alternativePremium || currentPremium <= alternativePremium) {
                displayData = {
                    showCurrent: true,
                    currentPremium,
                };
            } else {
                displayData = {
                    showBoth: true,
                    currentPremium,
                    alternativePremium,
                };
            }

            setSummaryData({
                premium: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : currentPremium,
                premiumTotal: userLoginType === "Failed Payment" || userLoginType === "Lapse" ? premiumFailed : parseFloat(userData.PaymentDetails.CurrentInsurerTotal || "0"),
                // policyDiscount: 40.00,
                deposit: parseFloat(userData.PaymentDetails.Deposit || "0"),
                interest: parseFloat(userData.PaymentDetails.Interest || "0"),
                payments: parseFloat(userData.PaymentDetails.Payments || "0"),
                // currentInsurerCharge: userLoginType === "Failed Payment" ? parseFloat(userData.PaymentDetails.Charge || "0") : parseFloat(userData.PaymentDetails.CurrentInsurerCharge || "0"),
                monthlyRepayment: 43.52,
                // totalChargeForCredit: 58.80,
                ...displayData, // Merging the insurer logic
            });
        }
    }, [userData, userLoginType, summaryData]);


    const formatSortCode = (code) => {
        const normalized = code.replace(/-/g, '').padStart(6, '0');
        return normalized.replace(/(\d{2})(\d{2})(\d{2})/, '$1-$2-$3');
    };

    const handelVerifyBankAccountDetails = async (ACCOUNTNUMBER, SORTCODE, onSuccess) => {
        try {
            const response = await axios.get(`https://api.addressy.com/bankaccountvalidation/interactive/validate/v2/json3.ws?Key=EJ96-HH44-RC27-DU25&AccountNumber=${ACCOUNTNUMBER}&SortCode=${SORTCODE}&`);
            const data = response.data;
            if (data.Items.length === 1 && typeof data.Items[0].Error !== "undefined") {
                // alert(data.Items[0].Description);
                Swal.fire({
                    title: 'Error!',
                    text: data.Items[0].Description,
                    icon: 'error',
                });
            } else if (data.Items.length === 0) {
                // alert("Sorry, there were no results.");
                Swal.fire({
                    title: 'Error!',
                    text: 'Sorry, there were no results.',
                    icon: 'error',
                });
            } else {
                const item = data.Items[0];
                // console.log("Validation Result:", item);
                if (item.IsCorrect) {
                    if (onSuccess) {
                        onSuccess();
                    } else {
                        // Fallback or remove if strictly navigating
                        setShowPaymentForm(true);
                    }
                } else {
                    // alert("Bank details are invalid.");
                    Swal.fire({
                        title: 'Error!',
                        text: 'Bank details are invalid.',
                        icon: 'error',
                    });
                }
            }
        } catch (error) {
            console.warn(error);
        }
    }


    const getDOBFromAge = (age) => {
        if (!age) return 'N/A';
        const today = new Date();
        const birthYear = today.getFullYear() - Number(age);
        const dob = new Date(birthYear, today.getMonth(), today.getDate());
        return dob.toLocaleDateString('en-GB');
    };

    const userName = userData?.ProposerDetails?.[1] ?
        userData?.ProposerDetails?.[0]?.["Proposer.Person.Title"] + ' ' + userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"] + ' ' + userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"] :
        userData?.ProposerDetails?.["Proposer.Person.Title"] + ' ' + userData?.ProposerDetails?.["Proposer.Person.Forenames"] + ' ' + userData?.ProposerDetails?.["Proposer.Person.Surname"];

    const userAge = userData?.ProposerDetails?.[1] ? userData?.ProposerDetails?.[0]?.["Proposer.Person.Age"] : userData?.ProposerDetails?.["Proposer.Person.Age"];

    const userAddress = [
        userData?.HomeDetails?.["Home.Address.AddrLine1"],
        userData?.HomeDetails?.["Home.Address.AddrLine2"],
        userData?.HomeDetails?.["Home.Address.AddrLine3"],
        userData?.HomeDetails?.["Home.Address.AddrLine4"],
    ].filter(Boolean).join(', ');

    const userPostcode = userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '';

    const detailsString = userData ? `Name: ${userName}\nDOB: ${getDOBFromAge(userAge)}\nAddress: ${userAddress}\nPostcode: ${userPostcode}` : '';

    const addonStatus = {
        legalPurchased: selectedAddons.includes("legal") ? "Yes" : "No",
        emergencyPurchased: selectedAddons.includes("emergency") ? "Yes" : "No",
        keysPurchased: selectedAddons.includes("key") ? "Yes" : "No",
        gadgetPurchased: selectedAddons.includes("gadget") ? "Yes" : "No",
    };


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            accountNumber: '',
            shortcode: '',
            accountHolderDetails: detailsString || '',
            fullName: userName || '',
            dob: getDOBFromAge(userAge) || '',
            address1: userData?.HomeDetails?.["Home.Address.AddrLine1"] || '',
            address2: userData?.HomeDetails?.["Home.Address.AddrLine2"] || '',
            address3: userData?.HomeDetails?.["Home.Address.AddrLine3"] || '',
            postcode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
            country: 'United Kingdom',
            phoneNumber: userData?.HomeDetails?.Telephone1 ? userData.HomeDetails.Telephone1.replace(/^\+?44/, '').replace(/^0/, '') : '',
            email: userEmail || '',
        },
        validationSchema: schema,
        onSubmit: (values) => {
            // setLoading(true)
            const formattedSortCode = formatSortCode(JSON.stringify(values.shortcode));
            console.log(JSON.stringify(values.accountNumber));

            const paymentModel = {
                Reference: refData.referenceCode,
                Name: cardInfoCorrect === 'no' ? values.fullName : userName,
                Address1: userData?.HomeDetails?.["Home.Address.AddrLine1"] || '',
                Address2: userData?.HomeDetails?.["Home.Address.AddrLine2"] || '',
                Address3: userData?.HomeDetails?.["Home.Address.AddrLine3"] || '',
                Address4: userData?.HomeDetails?.["Home.Address.AddrLine4"],
                Postcode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
                TotalToPay: plan.type === 'monthly' ? summaryData.showBoth ? selectInsurerType.type === 'currentInsurer' ? parseFloat(depositPrice).toFixed(2) : aiDepositPrice : parseFloat(depositPrice).toFixed(2)
                    : summaryData.showBoth ? selectInsurerType.type === 'currentInsurer' ? parseFloat(fullPrice).toFixed(2) : aitotalPrice : parseFloat(fullPrice).toFixed(2),
                Email: userEmail || '',
                PaymentReference: refData.referenceCode,
                payment: userLoginType === "Failed Payment"
                    ? "Premium"
                    : summaryData.showBoth
                        ? (selectInsurerType?.type === "currentInsurer" ? "Premium" : "Alternative Premium")
                        : summaryData.showCurrent
                            ? "Premium"
                            : summaryData.showAlternative
                                ? "Alternative Premium"
                                : "",
                Insurer: summaryData.showBoth ? selectInsurerType.type === 'alternativeInsurer' ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer
                    : userData?.PaymentDetails?.AlternativePolicyWording && userData?.PaymentDetails?.AlternativeInsurer ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer,
                phone: userData?.HomeDetails?.Telephone1 || '',
                schemeCode: userData?.HomeDetails?.SchemeCode,
                coverDate: userData?.HomeDetails?.["Policy.CoverDate"],
                pReturn: userLoginType,
                pCode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
                pRef: refData.referenceCode,
                currentInsurerCharge: brokerFee,
                legalPurchased: addonStatus.legalPurchased,
                emergencyPurchased: addonStatus.emergencyPurchased,
                keysPurchased: addonStatus.keysPurchased,
                gadgetPurchased: addonStatus.gadgetPurchased,
                accountNumber: values.accountNumber,
                sortCode: values.shortcode,
                accountHolderDetails: cardInfoCorrect === 'no' ?
                    `Name: ${values.fullName}\nDOB: ${values.dob}\nAddress: ${[values.address1, values.address2, values.address3].filter(Boolean).join(', ')}\nPostcode: ${values.postcode}` :
                    values.accountHolderDetails
            };

            const originalAddress = {
                address1: userData?.HomeDetails?.["Home.Address.AddrLine1"] || '',
                address2: userData?.HomeDetails?.["Home.Address.AddrLine2"] || '',
                address3: userData?.HomeDetails?.["Home.Address.AddrLine3"] || '',
                postcode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
                country: 'United Kingdom',
                phoneNumber: userData?.HomeDetails?.Telephone1 ? userData.HomeDetails.Telephone1.replace(/^\+?44/, '').replace(/^0/, '') : '1234567890',
                email: userEmail || '',
            };

            handelVerifyBankAccountDetails(JSON.stringify(values.accountNumber), formattedSortCode, () => {
                navigate('/pay-deposit', { state: { paymentModel: paymentModel, editableAddress: originalAddress, title: "Pay Deposit" } });
            });
            // console.log(formData)
            // navigate('/carddetails', { replace: true });
        }
    });
    const paymentModel = {
        Reference: refData.referenceCode,
        Name: cardInfoCorrect === 'no' ? formik.values.fullName : userName,
        Address1: userData?.HomeDetails?.["Home.Address.AddrLine1"] || '',
        Address2: userData?.HomeDetails?.["Home.Address.AddrLine2"] || '',
        Address3: userData?.HomeDetails?.["Home.Address.AddrLine3"] || '',
        Address4: userData?.HomeDetails?.["Home.Address.AddrLine4"],
        Postcode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
        TotalToPay: plan.type === 'monthly' ? summaryData.showBoth ? selectInsurerType.type === 'currentInsurer' ? parseFloat(depositPrice).toFixed(2) : aiDepositPrice : parseFloat(depositPrice).toFixed(2)
            : summaryData.showBoth ? selectInsurerType.type === 'currentInsurer' ? parseFloat(fullPrice).toFixed(2) : aitotalPrice : parseFloat(fullPrice).toFixed(2),
        Email: userEmail || '',
        PaymentReference: refData.referenceCode,
        payment: userLoginType === "Failed Payment"
            ? "Premium"
            : summaryData.showBoth
                ? (selectInsurerType?.type === "currentInsurer" ? "Premium" : "Alternative Premium")
                : summaryData.showCurrent
                    ? "Premium"
                    : summaryData.showAlternative
                        ? "Alternative Premium"
                        : "",
        Insurer: summaryData.showBoth ? selectInsurerType.type === 'alternativeInsurer' ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer
            : userData?.PaymentDetails?.AlternativePolicyWording && userData?.PaymentDetails?.AlternativeInsurer ? userData?.PaymentDetails?.AlternativeInsurer : userData?.HomeDetails?.Insurer,
        phone: userData?.HomeDetails?.Telephone1 || '',
        schemeCode: userData?.HomeDetails?.SchemeCode,
        coverDate: userData?.HomeDetails?.["Policy.CoverDate"],
        pReturn: userLoginType,
        pCode: userData?.HomeDetails?.["Home.Address.AddrPostCode"] || '',
        pRef: refData.referenceCode,
        currentInsurerCharge: brokerFee,
        legalPurchased: addonStatus.legalPurchased,
        emergencyPurchased: addonStatus.emergencyPurchased,
        keysPurchased: addonStatus.keysPurchased,
        gadgetPurchased: addonStatus.gadgetPurchased,
        accountNumber: formik.values.accountNumber,
        sortCode: formik.values.shortcode,
        accountHolderDetails: cardInfoCorrect === 'no' ?
            `Name: ${formik.values.fullName}\nDOB: ${formik.values.dob}\nAddress: ${[formik.values.address1, formik.values.address2, formik.values.address3].filter(Boolean).join(', ')}\nPostcode: ${formik.values.postcode}` :
            formik.values.accountHolderDetails
    };

    return (<>
        <Header />
        <div className='product-page-main-area'>
            <Container fluid>
                <Container>
                    <Row className='mt-4'>
                        <Col md={8}>
                            <div className='payment-page-left-area product-details-left'>
                                <div className="p-3 mb-3 payment-blue-header"><h4 className="mb-0 payment-header-text">Step 1: Set up Direct Debit</h4></div>
                                <div class="p-3 mb-3 payment-intro-box"><p class="mb-0 payment-intro-text">Thamesbank Insurance Services is a trading name of Paragon Car Ltd. We act as a credit broker and arrange premium finance exclusively through PremFina Ltd, who provide the loan.</p></div>
                                <div className='compliance-info mb-3'>
                                    <h4
                                        className='fw-bold mb-0 d-flex justify-content-between align-items-center h4-style'
                                        onClick={() => setShowComplianceInfo(!showComplianceInfo)}

                                    >
                                        A few things we'd like you to know
                                        <FontAwesomeIcon icon={showComplianceInfo ? faChevronUp : faChevronDown} style={{ fontSize: '16px' }} />
                                    </h4>
                                    {showComplianceInfo && (
                                        <ul className='list-class list-unstyled'>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Simple monthly payments:</strong> We can help set up your monthly payments, but please note that we are not the finance lender.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Who provides the finance:</strong> Your premium finance is provided by PremFina Ltd under a separate agreement from your insurance policy.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Being open with you:</strong> We receive a commission for arranging this service, PremFina Ltd will receive a £5.00 facility fee. By choosing monthly payments, you are agreeing to this. If you'd like more information about our commission, just ask.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Affordability checks:</strong> PremFina Ltd will carry out a credit check to confirm your identity and assess affordability. This will appear on your credit record and may be visible to other lenders.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>If your application isn't approved:</strong> PremFina Ltd will notify you, and we'll get in touch to discuss other payment options.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Your credit agreement:</strong> PremFina Ltd will email you a credit agreement to review and e-sign. This will explain the terms, including a £27.50 fee for any late or missed payments.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>If a payment can't be collected:</strong> PremFina Ltd may need to cancel the agreement and apply an additional £15.00 charge. Missed payments could also affect your future credit applications.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>For your insurance only:</strong> The finance can only be used to cover your insurance premium and related costs.</span></li>
                                            <li className='mb-2 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Changing your mind:</strong> You have 14 days to cancel the finance agreement if you wish. If you do, you'll still need to repay any credit already used.</span></li>
                                            <li className='mb-0 d-flex align-items-start'><FontAwesomeIcon icon={faCheckCircle} className="text-success me-2 mt-1" style={{ minWidth: '16px' }} /> <span><strong>Separate from your insurance policy:</strong> Because the credit agreement is separate from your insurance contract, if your policy is cancelled you'll still be liable for any cover used.</span></li>
                                        </ul>
                                    )}

                                    {/* <div className='mt-4'>
                                        <h5 className='fw-bold mb-2'>Need help?</h5>
                                        <p style={{ fontSize: '14px' }}>If you have any questions about your finance agreement, you can contact PremFina Ltd directly at <a href="https://www.premfina.com" target="_blank" rel="noreferrer">www.premfina.com</a>. You can also view your <a href="https://docs.thamesbankinsurance.co.uk/Pre-contract%20info.pdf" target="_blank" rel="noreferrer">pre-contract credit information</a> and the <a href="https://docs.thamesbankinsurance.co.uk/Direct%20Debit%20Guarantee.pdf" target="_blank" rel="noreferrer">Direct Debit Guarantee</a> by clicking on the relevant links.</p>
                                        <p style={{ fontSize: '14px' }}>As you have chosen to pay monthly, we now need your bank account details for your credit
                                            application and to set up a direct debit with the finance provider. Please be reassured, this is a
                                            secure SSL encrypted service, so your details are safe.</p>
                                    </div> */}
                                </div>




                                <div className='form-main mt-4'>
                                    <Form noValidate autoComplete="off">
                                        <Col md={12} className="drrect-debit">
                                            <img src={directDebit} alt="Direct Debit" />
                                        </Col>
                                        {/* <Row className="align-items-center"> */}
                                        <Col md={6}>
                                            <Form.Group controlId="accountNumber" className="position-relative mb-3">
                                                <Form.Label>Bank Account Number*</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Please enter..."
                                                    name="accountNumber"
                                                    value={formik.values.accountNumber}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.errors.accountNumber}
                                                    pattern="[0-9]*"
                                                    onKeyDown={(e) => {
                                                        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    isValid={formik.touched.accountNumber}
                                                />
                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {formik.errors.accountNumber}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group controlId="shortcode" className="position-relative mb-3">
                                                <Form.Label>Sort Code*</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Please enter..."
                                                    name="shortcode"
                                                    value={formik.values.shortcode}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    isInvalid={!!formik.errors.shortcode}
                                                    isValid={formik.touched.shortcode}
                                                    pattern="[0-9]*"
                                                    onKeyDown={(e) => {
                                                        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <Form.Control.Feedback type="invalid" tooltip>
                                                    {formik.errors.shortcode}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col md={6} className="text-center">
                                                <img src={directDebit} alt="Direct Debit" className="img-fluid" style={{ maxHeight: '180px' }} />
                                            </Col> */}
                                        {/* </Row> */}
                                        {/* Address Display Section */}
                                        <Col md={12} className="mb-3">
                                            {/* <Form.Group className="mb-4">
                                                <Form.Label className="fw-bold">Address:</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    readOnly
                                                    value={[formik.values.address1, formik.values.address2, formik.values.address3, formik.values.postcode, 'United Kingdom'].filter(Boolean).join('\n')}
                                                    style={{ backgroundColor: '#fff' }}
                                                />
                                            </Form.Group> */}
                                            <Form.Group as={Col} md="6" controlId="accountHolderDetails" className="position-relative mb-3">
                                                <Form.Label>Account Holder Details</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={8}
                                                    placeholder="Please enter..."
                                                    name="accountHolderDetails"
                                                    value={formik.values.accountHolderDetails}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                            </Form.Group>
                                            <div className="mb-0">
                                                <label className="fw-bold mb-3 d-block">Are the details for the account holder correct?</label>
                                                <div className="d-flex gap-3">
                                                    <button
                                                        type="button"
                                                        onClick={() => setCardInfoCorrect('yes')}
                                                        style={{
                                                            minWidth: '100px',
                                                            borderRadius: '6px',
                                                            padding: '8px 20px',
                                                            fontSize: '0.95rem',
                                                            fontWeight: '500',
                                                            transition: 'all 0.2s ease',
                                                            backgroundColor: cardInfoCorrect === 'yes' ? 'rgb(0, 102, 204)' : 'transparent',
                                                            color: cardInfoCorrect === 'yes' ? '#ffffff' : '#4a90e2',
                                                            border: cardInfoCorrect === 'yes' ? 'none' : '2px solid #4a90e2',
                                                            cursor: 'pointer'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (cardInfoCorrect !== 'yes') {
                                                                e.target.style.backgroundColor = '#227fc2ff';
                                                                e.target.style.color = '#ffffff';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (cardInfoCorrect !== 'yes') {
                                                                e.target.style.backgroundColor = 'transparent';
                                                                e.target.style.color = '#4a90e2';
                                                            }
                                                        }}
                                                    >
                                                        Yes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => setCardInfoCorrect('no')}
                                                        style={{
                                                            minWidth: '100px',
                                                            borderRadius: '6px',
                                                            padding: '8px 20px',
                                                            fontSize: '0.95rem',
                                                            fontWeight: '500',
                                                            transition: 'all 0.2s ease',
                                                            backgroundColor: cardInfoCorrect === 'no' ? 'rgb(0, 102, 204)' : 'transparent',
                                                            color: cardInfoCorrect === 'no' ? '#ffffff' : '#4a90e2',
                                                            border: cardInfoCorrect === 'no' ? 'none' : '2px solid #4a90e2',
                                                            cursor: 'pointer'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (cardInfoCorrect !== 'no') {
                                                                e.target.style.backgroundColor = '#cdd4d8ff';
                                                                e.target.style.color = '#ffffff';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (cardInfoCorrect !== 'no') {
                                                                e.target.style.backgroundColor = 'transparent';
                                                                e.target.style.color = '#4a90e2';
                                                            }
                                                        }}
                                                    >
                                                        No
                                                    </button>
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Conditional Address Inputs */}
                                        {cardInfoCorrect === 'no' && (
                                            <div className="mb-4 editable-address-section">
                                                <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Full Name:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="fullName"
                                                            value={formik.values.fullName}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mb-3 d-flex align-items-start">
                                                    <label className="form-label mb-0 editable-label">Date of birth:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="dob"
                                                            placeholder="DD/MM/YYYY"
                                                            value={formik.values.dob}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mb-3 d-flex align-items-start">

                                                    <label className="form-label mb-0 editable-label">Address:</label>
                                                    <div className="editable-field-wrapper">
                                                        {/* Address Line 1 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className={`form-control ${formik.touched.address1 && formik.errors.address1 ? 'is-invalid' : ''}`}
                                                                name="address1"
                                                                value={formik.values.address1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                placeholder="Address Line 1"
                                                            />
                                                            {formik.touched.address1 && formik.errors.address1 && (
                                                                <div className="invalid-feedback">{formik.errors.address1}</div>
                                                            )}
                                                        </div>

                                                        {/* Address Line 2 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="address2"
                                                                value={formik.values.address2}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                placeholder="Address Line 2"
                                                            />
                                                        </div>

                                                        {/* Address Line 3 */}
                                                        <div className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="address3"
                                                                value={formik.values.address3}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                placeholder="Address Line 3"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Postcode */}
                                                <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Postcode:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="text"
                                                            className={`form-control ${formik.touched.postcode && formik.errors.postcode ? 'is-invalid' : ''}`}
                                                            name="postcode"
                                                            value={formik.values.postcode}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.postcode && formik.errors.postcode && (
                                                            <div className="invalid-feedback">{formik.errors.postcode}</div>
                                                        )}
                                                    </div>
                                                </div>





                                                {/* <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Phone:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="phoneNumber"
                                                            value={formik.values.phoneNumber}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                    </div>
                                                </div> */}
                                                {/* <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Country</label>
                                                    <div className="editable-input-container">
                                                        <select
                                                            className="form-select"
                                                            name="country"
                                                            value={formik.values.country}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        >
                                                            <option value="United Kingdom">United Kingdom</option>
                                                            <option value="England">England</option>
                                                            <option value="Scotland">Scotland</option>
                                                            <option value="Wales">Wales</option>
                                                            <option value="Northern Ireland">Northern Ireland</option>
                                                        </select>
                                                    </div>
                                                </div> */}

                                                {/* Phone Number */}
                                                {/* <div className="mb-3 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Phone number:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="tel"
                                                            className="form-control"
                                                            name="phoneNumber"
                                                            value={formik.values.phoneNumber}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            placeholder="1234567890"
                                                        />
                                                    </div>
                                                </div> */}

                                                {/* Email Address */}
                                                {/* <div className="mb-0 d-flex align-items-center">
                                                    <label className="form-label mb-0 editable-label">Email address:</label>
                                                    <div className="editable-input-container">
                                                        <input
                                                            type="email"
                                                            className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                                                            name="email"
                                                            value={formik.values.email}
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.email && formik.errors.email && (
                                                            <div className="invalid-feedback">{formik.errors.email}</div>
                                                        )}
                                                    </div>
                                                </div> */}
                                            </div>
                                        )}

                                        <div className="d-flex align-items-center mt-3">
                                            <Button
                                                type="button"
                                                className='btn btn-lg continue-payment-btn'
                                                style={{ minWidth: '161px' }}
                                                onClick={formik.handleSubmit}
                                            >
                                                Continue to Payment
                                            </Button>
                                        </div>

                                        {/* <div className="mb-4 mt-4">
                                            <div
                                                className={`p-3 mb-0 payment-form-header ${cardInfoCorrect === 'yes' ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                                                onClick={() => { if (cardInfoCorrect === 'yes') formik.handleSubmit(); }}
                                            >
                                                <h4 className="mb-0 payment-header-text">Step 2: Pay Deposit</h4>
                                            </div>
                                            {/* Payment form moved to a new page 
                                        </div> */}
                                        {/* <div>
                                            <Link to="/product" className='btn btn-lg btn-light me-3'>Previous</Link>
                                            <Button type="button" className='btn btn-lg continue-payment-btn mt-3' style={{ minWidth: '161px' }} onClick={formik.handleSubmit}>Continue to Payment</Button>
                                        </div> */}
                                        <Link to="/product" className='btn btn-lg btn-light me-3 mt-3' style={{ minWidth: '161px' }}>
                                            Previous
                                        </Link>
                                    </Form>
                                    <div className='mt-4'>
                                        <h5 className='fw-bold mb-2'>Need help?</h5>
                                        <p style={{ fontSize: '15px' }}>If you have any questions about your finance agreement, you can contact PremFina Ltd directly at <a href="https://www.premfina.com" target="_blank" rel="noreferrer">www.premfina.com</a>. You can also view your <a href="https://docs.thamesbankinsurance.co.uk/Pre-contract%20info.pdf" target="_blank" rel="noreferrer">pre-contract credit information</a> and the <a href="https://docs.thamesbankinsurance.co.uk/Direct%20Debit%20Guarantee.pdf" target="_blank" rel="noreferrer">Direct Debit Guarantee</a> by clicking on the relevant links.</p>
                                        <p style={{ fontSize: '15px' }}>As you have chosen to pay monthly, we now need your bank account details for your credit
                                            application and to set up a direct debit with the finance provider. Please be reassured, this is a
                                            secure SSL encrypted service, so your details are safe.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <PriceSummery />
                            <div className="mt-4">
                                {/* Quote Reference Box */}
                                <div className="mb-3 p-4 text-white rounded sidebar-box-green">
                                    <h5 className="mb-1 sidebar-label">Quote Reference</h5>
                                    <h3 className="mb-3 fw-bold">{refData.referenceCode}</h3>
                                    <hr className="my-3 sidebar-divider" />
                                    <p className="mb-1 sidebar-label">If you need help call us on</p>
                                    <h3 className="mb-3 fw-bold">0203 302 9263</h3>
                                    <hr className="my-3 sidebar-divider" />
                                    <h5 className="mb-0">Home Insurance</h5>
                                </div>

                                {/* Your Security Box */}
                                <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                    <h4 className="fw-bold mb-3 sidebar-heading-small">Your security:</h4>
                                    <p className="small mb-3">Your information is secured with a 256 bit SSL connection provided by our technology partner GoDaddy.</p>
                                    <img src={godaddyImage} alt="SSL Connection" className="img-fluid" />
                                    {/* <img src="https://thamesbankassets.netlify.app/godaddy_dark.png" alt="GoDaddy Verified & Secured" className="img-fluid" /> */}
                                </div>

                                {/* Contact Us Box */}
                                <div className="mb-3 p-4 text-white rounded sidebar-box-dark">
                                    <h4 className="fw-bold mb-3 sidebar-heading-small">Contact us:</h4>
                                    <p className="mb-1 small">Call us on our phone number</p>
                                    <h4 className="mb-3 fw-bold">0203 302 9263</h4>

                                    <p className="mb-1 small">Email:</p>
                                    <p className="mb-3 fw-bold sidebar-label">sales@thamesbankinsurance.co.uk</p>

                                    <h4 className="fw-bold mb-2 sidebar-heading-small">Office Hours:</h4>
                                    <p className="mb-1 fw-bold">Mon to Thur</p>
                                    <p className="mb-2 small">9.00 am to 6.30 pm</p>
                                    <p className="mb-3 small">Fri 9.00 am to 5.30 pm</p>

                                    <p className="small lh-sm sidebar-tiny-text">
                                        Thamesbank Insurance Services is a trading name of Paragon Car Limited and are authorised and regulated by the Financial Conduct Authority, FCA no: 312028
                                    </p>
                                </div>

                                {/* Payment Options Box */}
                                <div className="mb-3 p-4 bg-white rounded shadow-sm">
                                    <h4 className="fw-bold mb-3 sidebar-heading-small">Payment options:</h4>
                                    <p className="small mb-3">We accept all major credit and debit cards and offer payment by monthly instalments under the Direct Debit Guarantee</p>
                                    <img src="https://thamesbankassets.netlify.app/cardLogos.png" alt="Visa Mastercard Maestro Direct Debit" className="img-fluid" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container >
        </div >
        <Footer />
    </>);
}




export default BankDetails;